module.exports = __webpack_public_path__ + "static/maw_demon-d1083784c758d7ac0af4e0dbb15f27c5.jpeg";